<template>
  <div class="tradeModel">
    <div class="layout">
      <div class="money">
        <ul>
          <li><p>总收入</p><span v-if="credit.total" :class="classType(credit.total.totalIncome)">{{ credit.total.totalIncome&&credit.total.totalIncome>0?'+':credit.total.totalIncome==0?'':'-' }}${{ parseFloat(credit.total.totalIncome).toFixed(2).replace('-','').replace('+','') }}<em /></span></li>
          <li><p>总支出</p><span v-if="credit.total" :class="classType(credit.total.totalExpenditure)">{{ credit.total.totalExpenditure&&credit.total.totalExpenditure>0?'+':credit.total.totalExpenditure==0?'':'-' }}${{ parseFloat(credit.total.totalExpenditure).toFixed(2).replace('-','').replace('+','') }}<em /></span></li>
        </ul>
      </div>
      <div class="reportTit">
        <p>共计{{ credit.totalSize }}条记录</p>
        <span @click="selectBrush">筛选<img src="@/assets/images/template/SX.png"></span>
      </div>
    </div>
    <div v-if="credit.recordList" class="reportList">
      <ul v-if="credit.recordList.length>0">
        <li v-for="item in credit.recordList" @click="selectCreditPro(item)">
          <div class="item marginBottom">
            <div class="itemCon">
              <div class="flexStart">
                <div class="itemWidth"><p>{{ timeZone(item.jointime,0) }}</p></div>
                <div class="itemWidth"><p>{{ item.cusTranTypeStr }}</p></div>
              </div>
              <div class="flexStart">
                <div class="itemWidth"><p>周{{ new Date((item.jointime).replace(/-/g, "/")).format("E") }}</p></div>
                <div class="itemWidth"><p class="color">余额</p><p>{{ item.amountDst }}</p></div>
              </div>
            </div>
            <div class="flexEnd">
              <p class="size" :class="item.income==0?classType(item.expenditureStr):classType(item.income)">{{ item.income==0?item.expenditureStr>0?'+':'-':item.income>0?'+':'-' }}${{ item.income==0?parseFloat(item.expenditureStr).toFixed(2).replace('-','').replace('+',''):parseFloat(item.income).toFixed(2).replace('-','').replace('+','') }}</p>
            </div>
          </div>
        </li>
      </ul>
      <noData v-else />
    </div>
    <!--额度详情-->
    <div v-if="isShowCredit" class="popFixed">
      <div class="masking" @click="closeCreditPop" />
      <div class="tcCon">
        <div class="holdBank between">
          <div class="item">
            <span>交易详情</span>
            <ul>
              <li><span>时间</span><span>{{ timeZone(jointime,1) }}</span></li>
              <li><span>项目</span><span>{{ cusTranTypeStr }}</span></li>
              <li><span>变动前额度</span><span>{{ amountSrc }}</span></li>
              <li><span>收入</span><span>{{ parseFloat(income).toFixed(2) }}</span></li>
              <li><span>支出</span><span>{{ expenditureStr }}</span></li>
              <li><span>变动后额度</span><span>{{ amountDst }}</span></li>
              <li><span>流水号</span><span>{{ pno }}</span></li>
              <li><span>备注</span><span>{{ remark }}</span></li>
            </ul>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="closeCreditPop">知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from '@/view/module/noData.vue'
import utils from '@/utils/tradeDataUtil'
export default {
  name: 'CreditRecord',
  components: { noData },
  props: ['credit', 'isBrushTradePop'],
  data() {
    return {
      isShowCredit: false,
      jointime: '',
      cusTranTypeStr: '',
      amountSrc: '',
      income: '',
      expenditureStr: '',
      amountDst: '',
      pno: '',
      remark: '',
      scrollHeight: '',
      pattern: this.$route.query.pattern || '',
      timeZones: this.$route.query.timeZones || ('GMT+8')
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    removeStyle() {
      const main = document.getElementById('main')
      main.removeAttribute('style')
      window.scrollTo(0, this.scrollHeight)
    },
    addStyle() {
      const main = document.getElementById('main')
      let top, body, css
      if (document.documentElement) {
        body = document.documentElement
      } else if (document.body) {
        body = document.body
      }
      if (body.scrollTop) {
        top = body.scrollTop
      } else if (window.pageYOffset) {
        top = window.pageYOffset
      }
      css = 'width: 100%; height: 100%; position: fixed; top: -' + top + 'px;left: 0;'
      main.style.cssText = css
      this.scrollHeight = top
    },
    timeZone(val, type) {
      if (!val) return ''
      if (val) {
        const localTime = utils.getLocalTime(Number(this.timeZones.substr(3)), val)
        if (type == 0) return new Date(localTime).format('Y-MM-dd')
        else if (type == 1) return new Date(localTime).format('Y-MM-dd hh:mm:ss')
      }
    },
    closeCreditPop() {
      this.removeStyle()
      this.isShowCredit = false
    },
    selectCreditPro(data) {
      this.addStyle()
      this.isShowCredit = !this.isShowCredit
      this.jointime = data.jointime
      this.cusTranTypeStr = data.cusTranTypeStr
      this.amountSrc = data.amountSrc
      this.income = data.income
      this.expenditureStr = data.expenditureStr
      this.amountDst = data.amountDst
      this.pno = data.pno
      this.remark = data.remark
    },
    selectBrush() {
      this.toggleFixed()
      let isShowTradeType = this.isBrushTradePop
      isShowTradeType = !isShowTradeType
      this.$emit('blushPop', isShowTradeType)
    },
    classType(obj) {
      let val
      if (this.pattern) {
        if (this.pattern == 'redGreen') {
          if (obj > 0) val = 'fall reverse'
          else if (obj < 0) val = 'rise reverse'
          else if (obj == 0) val = ''
          else if (obj == '买') val = 'sell'
          else if (obj == '卖') val = 'buy'
        } else if (this.pattern == 'greenRed') {
          if (obj > 0) val = 'rise'
          else if (obj < 0) val = 'fall'
          else if (obj == 0) val = ''
          else if (obj == '买') val = 'buy'
          else if (obj == '卖') val = 'sell'
        }
      } else {
        if (obj > 0) val = 'rise'
        else if (obj < 0) val = 'fall'
        else if (obj == 0) val = ''
        else if (obj == '买') val = 'buy'
        else if (obj == '卖') val = 'sell'
      }
      return val
    }
  }
}
</script>
